// Per-organisation feature configuration. Mirrors data.organisation_config
// (migration 014). Owned by the Admin → Organisation editor; consumed by
// Weekly Schedule, Attendance UI, and the report header.
export interface OrgConfig {
  /** Slot length on the Weekly Schedule grid (minutes). One of
   *  5, 10, 15, 20, 30, 45, 60, 90, 120 (matches CHECK constraint). */
  defaultSessionIntervalMinutes: number;
  /** Whether Saturday + Sunday rows render on the schedule grid. */
  includeWeekends: boolean;
  /** Working day window the schedule renders. 'HH:MM' (24h). */
  workingDayStart: string;
  workingDayEnd: string;
  /** ± minutes around the scheduled time within which an arrival or
   *  departure classifies as "on-time". 0–60 inclusive. */
  attendanceGraceMinutes: number;
  /** Display label for the report header "Setting" row. Null → caller
   *  falls back to security.organisation.name. */
  settingName: string | null;
  /** Child-data retention policy (child-deletion epic, migration 037).
   *  'dob25' = keep until the child's 25th birthday (needs a DOB on the
   *  profile; falls back to 'leaving' when absent). 'leaving' = keep for
   *  retentionYearsAfterLeaving after the leaving date. */
  retentionAnchor: 'leaving' | 'dob25';
  /** Years after leaving before hard delete is due (leaving anchor). 0–30. */
  retentionYearsAfterLeaving: number;
  /** Comma-separated recipients for retention reminders. Null → the
   *  monitor falls back to the org's Admin users' emails. */
  deletionNotifyEmails: string | null;
}

// Safe defaults — used while the config is loading and as fallbacks when
// a page is reached without an org selected (rare). Match the DB defaults
// in migration 014 so behaviour is consistent before/after first load.
export const ORG_CONFIG_DEFAULTS: OrgConfig = {
  defaultSessionIntervalMinutes: 30,
  includeWeekends: false,
  workingDayStart: '08:00',
  workingDayEnd: '18:00',
  attendanceGraceMinutes: 5,
  settingName: null,
  retentionAnchor: 'leaving',
  retentionYearsAfterLeaving: 6,
  deletionNotifyEmails: null,
};
